import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Accredible|Duplicate Management|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareAccredibleBadging,
	portal: 'SP',
};

type LocNameStart = 'SPToolsAccredibleDuplicateManagement';
export type SPToolsAccredibleDuplicateManagementLocNames =
	| `${LocNameStart}TitleTable`
	| `${LocNameStart}ContentDuplicatesFound`
	| `${LocNameStart}LabelCmcId`
	| `${LocNameStart}LabelCertmetricsId`
	| `${LocNameStart}LabelAccredibleId`
	| `${LocNameStart}LabelFirstName`
	| `${LocNameStart}LabelLastName`
	| `${LocNameStart}LabelEmail`;

export const spToolsAccredibleDuplicateManagementLocs: LocDefs<SPToolsAccredibleDuplicateManagementLocNames> =
	{
		SPToolsAccredibleDuplicateManagementTitleTable: {
			defaultValue: 'Accredible Mismatched or Duplicate Emails',
			description: 'Table Title',
			displayPath: `${pathStart}Table Title`,
			displayType: 'Title',
			legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.Title.Anomalies',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPToolsAccredibleDuplicateManagementContentDuplicatesFound: {
			defaultValue:
				"This candidate's email address was found on multiple candidate accounts or is listed as a Accredible ID under another profile. Please review the search results to investigate further.",
			description: 'Description of duplicates found.',
			displayPath: `${pathStart}Duplicates Found`,
			displayType: 'Content',
			legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.Content.DuplicatesFound',
			htmlAllowed: true,
			...sharedProperties,
		},
		SPToolsAccredibleDuplicateManagementLabelCmcId: {
			defaultValue: 'CMC ID',
			description: 'Column heading for: CMC ID.',
			displayPath: `${pathStart}CMC ID`,
			displayType: 'Label',
			legacyName:
				'Share.AccredibleBadging/Accredible.BadgeSearchDuplicates.ColumnHeading.CMCId',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPToolsAccredibleDuplicateManagementLabelCertmetricsId: {
			defaultValue: 'Certmetrics ID',
			description: 'Column heading for: Certmetrics ID.',
			displayPath: `${pathStart}Certmetrics ID`,
			displayType: 'Label',
			legacyName:
				'Share.AccredibleBadging/Accredible.BadgeSearchDuplicates.ColumnHeading.CMId',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPToolsAccredibleDuplicateManagementLabelAccredibleId: {
			defaultValue: 'Accredible ID',
			description: 'Column heading for: Accredible ID.',
			displayPath: `${pathStart}Accredible ID`,
			displayType: 'Label',
			legacyName:
				'Share.AccredibleBadging/Accredible.BadgeSearchDuplicates.ColumnHeading.AccredibleId',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPToolsAccredibleDuplicateManagementLabelFirstName: {
			defaultValue: 'First Name',
			description: 'Column heading for: First Name.',
			displayPath: `${pathStart}First Name`,
			displayType: 'Label',
			legacyName:
				'Share.AccredibleBadging/Accredible.BadgeSearchDuplicates.ColumnHeading.FirstName',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPToolsAccredibleDuplicateManagementLabelLastName: {
			defaultValue: 'Last Name',
			description: 'Column heading for: Last Name.',
			displayPath: `${pathStart}Last Name`,
			displayType: 'Label',
			legacyName:
				'Share.AccredibleBadging/Accredible.BadgeSearchDuplicates.ColumnHeading.LastName',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPToolsAccredibleDuplicateManagementLabelEmail: {
			defaultValue: 'Email',
			description: 'Column heading for: Email.',
			displayPath: `${pathStart}Email`,
			displayType: 'Label',
			legacyName:
				'Share.AccredibleBadging/Accredible.BadgeSearchDuplicates.ColumnHeading.Email',
			htmlAllowed: false,
			...sharedProperties,
		},
	};

export type SPToolsAccredibleDuplicateManagementLocType =
	LocMap<SPToolsAccredibleDuplicateManagementLocNames>;
